import React, { useState } from "react";
import BaseModal from "../BaseModal/index";
import Button from "../../Buttons/Button";
import PatientName from "../Common/PatientName";
import TextArea from "../Common/TextArea";
import FlyerMessage from "../../FlyerMessage";

/**
 * Modal for Sending Message to Patient
 * @param {function} onClose - Function to handle the modal close event
 * @param {object} patientInfo - Information about the patient
 */
export const MessageToPatient = ({ onClose, patientInfo }) => {
  const [message, setMessage] = useState("");
  const [isMessageSent, setIsMessageSent] = useState(false);

  // Event handler for when the user types a message
  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  // Event handler for when the user clicks the "Send" button
  const handleSend = async (event) => {
    try {
      // Replace with your actual API call
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // After successful send, set the state to show FlyerMessage
      setIsMessageSent(true);
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  // Event handler for when the user clicks the "Close" button on FlyerMessage
  const handleFlyerMessageClose = () => {
    onClose();
    // Reset the state to hide FlyerMessage
    setIsMessageSent(false);
  };

  return (
    //BaseModal, PatientName, TextArea, Button are reusable components - pass respective props
    <BaseModal
      title="Send Message"
      onClose={onClose}
      showFlyerMessage={isMessageSent}
      flyerMessageText={"Message has been sent successfully!"}
      onFlyerMessageClose={handleFlyerMessageClose}
    >
      <PatientName {...patientInfo} />
      <TextArea
        textAreaType="message"
        placeholder="Type your message here..!"
        value={message}
        onChange={handleMessageChange}
      />
      <Button btnType="send" onClick={handleSend} />
    </BaseModal>
  );
};
